import { capitalize, replaceAllUnderscoreToSpace } from "./string";
export var getCourierName = function getCourierName(courier) {
  if (!courier) return '';
  var withoutUnderscore = replaceAllUnderscoreToSpace(courier);
  return capitalize(withoutUnderscore);
};